// The start component displays instructions for the user and a Start button. When the start button is clicked, the page immediately changes to the grid using the router link.

import React, { Component } from 'react';
import './start.css'
import { Link } from "react-router-dom";

class Start extends Component {

    render() {

        return (
            <div id="start">
                <div id="instructions">
                    <h3 id="instructionsHeader">Instructions</h3>
                    <p id="instructionsPara">When you press start you will have 90 seconds to press the "ink" colour of the words that appear. Thus, if you see the word "Purple" written in pink ink, you need to press the "Pink" tile, and not the "Purple" one.</p>
                </div>
                <Link id="startButton" to="/screen/" onClick={this.props.reset}><span>Start</span></Link>
            </div>
        )
    }
}

export default Start;